<div class="main">
  <app-header *ngIf="headerSubject$ | async" [user]="user"></app-header>
  <app-page-loader></app-page-loader>
  <div class="sub-container">
    <router-outlet></router-outlet>
  </div>
</div>
